module.exports = __webpack_public_path__ + "static/media/wyeth.7f2b64f9.png";